import { render, staticRenderFns } from "./locationwisereport.vue?vue&type=template&id=756c829e&scoped=true&"
import script from "./locationwisereport.vue?vue&type=script&lang=js&"
export * from "./locationwisereport.vue?vue&type=script&lang=js&"
import style0 from "./locationwisereport.vue?vue&type=style&index=0&id=756c829e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756c829e",
  null
  
)

export default component.exports